/**
 * Platform-wise config for Stop Loss logs child rows only.
 * Parent row rendering is unchanged.
 */
export const STOP_LOSS_LOGS_CHILD_COLUMN_CONFIG = {
  amazon: {
    impact: {
      showImage: true,
      statsDataPath: "metrices?.productStatsData",
      productNameKey: "productNameWithImage",
      entityIdKey: "asin",
    },
    ad_spend_saved: {
      statsDataPath: "metrices?.productStatsData",
      metricKey: "cost",
    },
  },
  flipkart: {
    impact: {
      showImage: false,
      statsDataPath: "metrices?.productStatsData",
      productNameKey: "productName",
      entityIdKey: "fsn",
    },
    ad_spend_saved: {
      statsDataPath: "metrices?.productStatsData",
      metricKey: "spends",
    },
  },
  myntra: {
    impact: {
      showImage: false,
      statsDataPath: "metrices?.productStatsData",
      productNameKey: "productName",
      entityIdKey: "productId",
      entityIdFallbackKeys: ["style_id", "styleId", "product_id"],
    },
    ad_spend_saved: {
      statsDataPath: "metrices?.productStatsData",
      metricKey: "spends",
    },
  },
};

export const getStopLossLogsChildConfig = (platform) => {
  const normalizedPlatform = platform?.toLowerCase?.() ?? "amazon";
  return (
    STOP_LOSS_LOGS_CHILD_COLUMN_CONFIG[normalizedPlatform] ??
    STOP_LOSS_LOGS_CHILD_COLUMN_CONFIG.amazon
  );
};
